<template>
  <div>
    <div class="login">
      <div class="container">
        <div class="logo">
          <a href="#" class="logo-link">
            <img src="/static/images/torepi-logo.png" alt="" class="mb-4 logo-img">
          </a>
        </div>
        <div class="login-box">
            <div class="err">リンクの有効期限が切れました。再度パスワードの設定依頼をしてください。</div>
            <div class="form-footer text-center">
                <p class="text"><a href="#" class="link"> <router-link :to="{name: 'reset_password'}">こちら</router-link></a>で再発行してください。</p>
            </div>
        </div>
        <div class="copyright">
          <span>株式会社SOFTNEXT©2020 All rights reserved</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'error'
}
</script>
<style scoped lang="scss">
@import '@/assets/stylesheet/auth/login.scss';

.err {
    color: #ff0000;
    font-family: "Nunito Sans",sans-serif;
    font-size: 2rem;
    margin: auto;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/Token401.vue